import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { Headers, Http } from '@angular/http';
import { environment } from '../environments/environment';


@Component({
  selector: 'bw-root',
  templateUrl: './bw.component.html',
  styleUrls: ['./bw.component.css']
})
export class BwComponent implements OnInit {

  constructor (
    private router: Router,
    private http: Http,
  ) {
    const self = this;
    $('body').on('click', '*[bw-router]', function (event) {
      if ($(this).attr('bw-router') !== '') {
        self.router.navigateByUrl($(this).attr('bw-router'));
      }
    });
  }

  ngOnInit (): void {
    // 全局病区缓存数据
    /**
     * TODO: 日后修改全部字典表
     *       sfy_district 市妇幼字典
     */
     this.http.get(environment.baseUrl + `tlc-advice-info/sys/dict/getDictItems/sfy_district`, {}).subscribe(
        (res: any) => {
          const data = JSON.parse(res._body);
          if(data.code == 0  && data.data && Array.isArray(data.data)) {
            localStorage.setItem('dictItems', JSON.stringify(data.data));
          }
        }, (error: any) => {
          swal('请求失败', error.result.displaymsg, 'warning');
        }
      )
  }

}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/bw.component.ts